export const unicoUrl = `${window.location.origin}/unico`;

export const unicoUrlParams = '?modulo=4';
